<template>
  <portal to="root-modal-target">
    <div
      :class="[ modalClass, genericClass ]"
      data-test-id="a-modal"
    >
      <slot />
    </div>
  </portal>
</template>

<script>
const CLASSES = Object.freeze({
  active: 'active',
  modal: 'modal',
  roundDarkModal: 'round-dark-modal',
});

export default {
  props: {
    roundDark: {
      type: Boolean,
      default: false,
    },
    modalClass: {
      type: String,
      default: null,
    },
  },
  computed: {
    genericClass() {
      return this.roundDark
        ? [ CLASSES.active, CLASSES.roundDarkModal ]
        : [ CLASSES.active, CLASSES.modal ];
    },
  },
};
</script>
